import React from 'react'
import SettingsMenu from 'navigation/sub-routes/Settings/SettingsMenu'
import {Outlet} from 'react-router-dom'

const SettingsLayout = () => {
  return (
    <>
      <SettingsMenu />
      <div className="vmoSideBar-wrap">
        <Outlet />
      </div>
    </>
  )
}

export default SettingsLayout
